import api from '@/tools/api-tools'
import * as urls from '../../config/net'
import resUrl from './resource-url'

class StdGoodsEntity {
  static SAAS_TYPE = 1
  static HARDWARE_TYPE = 2

  static goodsInfo ({goodsId, goodsType, quantity = 1, remark = ''}) {
    let payObj = {goodsId, goodsType, quantity, remark}
    return api.post(resUrl.mainWebUrl, urls.mainWebPostData('businfo', payObj)).then(res => {
      let model = {}
      try {
        model = JSON.parse(res.data.Model) || {}
      } catch (e) {
      }
      return model
    }).catch(e => {
      console.log(e)
      return {}
    })
  }

  // 将goodsInfo内容中的优惠券信息提取出来
  static CouponListModels (responseObj) {
    return (responseObj.CouponList || {}).CouponListModels || []
  }

  // 积分是否可用，0代表不可用，1代表可用
  static IntegralModels (responseObj) {
    return responseObj.IsShowCommuteIntegral
  }
}

export default StdGoodsEntity



// WEBPACK FOOTER //
// ./src/model/std-goods-entity/index.js